<template>
  <div class="xcard">
		<p class="text-center"> <b>Cargos y Roles del Sistema.</b> </p>
    <p class="text-center text-danger"> <b>ADVERTENCIA:</b> Los datos de esta tabla son muy sensibles y delicados para el sistema, si usted no esta capacitado para el uso de este modulo, por favor no toque nada y salga inmediatamente sin hacer ruido. </p>
    <br>
    <br>
    <table class="table table-condensed table-hover">
      <thead style="background:#196391;">
        <tr class="white--text">
          <th>Nro</th>
          <th>Nombre del cargo</th>
					<th>Modulos</th>
        </tr>
      </thead>

      <tbody>
        <tr v-bind:key="ind" v-for="(c,ind) in cargos" @click="editarCargo(c)" class="tr_cargo">
          <td> {{c.id}} </td>
          <td :title="c.id"> {{c.nombre}} </td>
					<td>  {{c.menuscargo.length}} </td>
        </tr>
      </tbody>
    </table>

    <Alertas ref="alertar" />
		<notifications group="auth" position="bottom right" />
  </div>
</template>

<script> 
import gql from 'graphql-tag';
import {parseJsonError} from '@/components/Utils.js'
import Alertas from '@/components/AAlertas.vue'
export default {
  data(){
    return{
      cargos:[],
    }
  },
  components:{Alertas},
  methods:{
		editarCargo( c ){
			if( this.$store.state.CARGO.id == 1 ){
				window.sessionStorage.setItem( "xcargoedit",JSON.stringify(c) );
				this.$router.push({name:'cargoedit'});
			}
		},
    async getDatos(){
      this.$refs.alertar.cargando();
      var sql = gql`query{ getCargos{id,nombre,descripcion,menuscargo{idmenu}} }`;
      await this.$apollo.query({
				query: sql,
			}).then((data) => {
        this.cargos = data.data.getCargos;
        this.$refs.alertar.reset();
        // window.console.log( ">>>",this.cargos );
			}).catch((error) => {
        // window.console.error(error)
        this.$notify( parseJsonError( error,'getCargos' ) )
			});
    }
  },
  mounted(){
    this.getDatos();
    // window.console.error( "hola mudno" );
  }
}
</script>